import { type FC, useCallback, useEffect, useState } from 'react';
import { Flex, Text } from '@eqi-investimentos/react';
import ReactCurrencyInput from 'react-currency-input-field';
import { Aeonik } from '@/themes/fonts';
export const CurrencyInput: FC<CurrencyInputProps> = ({
  changeValueCallback
}) => {
  const [inputVal, setInputVal] = useState(defaultInitValue);
  const isInitialVal = inputVal === defaultInitValue;
  useEffect(() => {
    changeValueCallback(defaultInitValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleMore = useCallback(() => {
    setInputVal(prev => {
      if (!prev || isNaN(parseFloat(prev))) {
        return defaultInitValue;
      }
      const plusMoney = Number(parseFloat(String(prev).indexOf(',') ? String(prev).replace(',', '.') : prev).toFixed(2)) + Number(10000);
      const newValue = parseFloat(plusMoney.toString()).toFixed(2).toString();
      changeValueCallback(newValue);
      return newValue;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleMinus = useCallback(() => {
    setInputVal(prev => {
      const minusMoney = Number(parseFloat(String(prev).indexOf(',') ? String(prev).replace(',', '.') : prev).toFixed(2)) - Number(10000);
      if (prev <= defaultInitValue) return defaultInitValue;
      if (minusMoney < 0) return defaultInitValue;
      const newValue = parseFloat(minusMoney.toString()).toFixed(2).toString();
      changeValueCallback(newValue);
      return newValue;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Flex justifyContent="center" alignItems="center" py="m" sx={{
    button: {
      border: '1px solid transparent'
    },
    '#input-currency-invest': {
      w: 'full',
      minW: 'calc(100% - 20.625rem)',
      h: '3.75rem',
      fontFamily: Aeonik.style.fontFamily,
      fontSize: 'md',
      color: 'content.primary',
      textAlign: 'center',
      borderX: '1px solid transparent !important',
      borderY: '1px solid var(--eqi-colors-border-secondary) !important',
      boderColor: 'border.secondary',
      _focus: {
        border: 'none',
        boxShadow: 'none',
        outline: 'none'
      },
      _focusVisible: {
        border: 'none',
        boxShadow: 'none',
        outline: 'none'
      },
      _focusWithin: {
        border: 'none',
        boxShadow: 'none',
        outline: 'none'
      }
    }
  }} data-sentry-element="Flex" data-sentry-component="CurrencyInput" data-sentry-source-file="index.tsx">
      <Flex id="currency_input_button_minus" onClick={handleMinus} px="20" py="m" borderStartStartRadius={8} borderEndStartRadius={8} backgroundColor={isInitialVal ? 'action.disabled' : 'action.active.brandLight'} align="center" justify="center" cursor={isInitialVal ? 'not-allowed' : 'pointer'} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Text size="h6" color="content.primary" fontWeight="medium" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          -
        </Text>
      </Flex>
      <ReactCurrencyInput id="input-currency-invest" name="input-name" allowNegativeValue={false} prefix="R$ " defaultValue={10000.0} allowDecimals={true} decimalsLimit={2} decimalSeparator="," groupSeparator="." intlConfig={{
      locale: 'pt-BR',
      currency: 'BRL'
    }} value={inputVal} onValueChange={value => {
      if (value) {
        setInputVal(value);
        changeValueCallback(value);
      }
    }} data-sentry-element="ReactCurrencyInput" data-sentry-source-file="index.tsx" />
      <Flex id="currency_input_button_more" cursor="pointer" onClick={handleMore} py="m" px="20" borderStartEndRadius={8} borderEndEndRadius={8} backgroundColor="action.active.brandLight" align="center" justify="center" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Text size="h6" color="content.primary" fontWeight="medium" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          +
        </Text>
      </Flex>
    </Flex>;
};
const defaultInitValue = '10000.00';
type CurrencyInputProps = {
  changeValueCallback: (value: string) => void;
};